<div class="container">
    <div class="unauthorizedMessage">
        Authorization Failed - You don’t have access to requested page
    </div>
    <div class="con-app-logout" (click)="logout()">
       
        <div class="item-label">
          Logout
        </div>
      </div>
</div>
